import { render, staticRenderFns } from "./BlwHero.vue?vue&type=template&id=2555e53b&"
import script from "./BlwHero.vue?vue&type=script&lang=js&"
export * from "./BlwHero.vue?vue&type=script&lang=js&"
import style0 from "./BlwHero.vue?vue&type=style&index=0&id=2555e53b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports